import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './index.css'

// FontAwesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faHome,
  faFileAlt,
  faCheck,
  faExclamationTriangle,
  faExclamationCircle,
  faCheckCircle,
  faInfoCircle,
  faArrowRight,
  faArrowLeft,
  faDollarSign,
  faFileInvoiceDollar,
  faBuilding,
  faGavel,
  faFileContract,
  faUpload,
  faDownload,
  faSpinner,
  faTimes,
  faPlus,
  faMinus,
  faEdit,
  faTrash,
  faSave,
  faUndo,
  faCloudUploadAlt,
  faFileUpload,
  faFilePdf,
  faBalanceScale,
  faLandmark,
  faUserTie,
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faHome,
  faFileAlt,
  faCheck,
  faExclamationTriangle,
  faExclamationCircle,
  faCheckCircle,
  faInfoCircle,
  faArrowRight,
  faArrowLeft,
  faDollarSign,
  faFileInvoiceDollar,
  faBuilding,
  faGavel,
  faFileContract,
  faUpload,
  faDownload,
  faSpinner,
  faTimes,
  faPlus,
  faMinus,
  faEdit,
  faTrash,
  faSave,
  faUndo,
  faCloudUploadAlt,
  faFileUpload,
  faFilePdf,
  faBalanceScale,
  faLandmark,
  faUserTie,
  faPhone,
  faEnvelope,
  faMapMarkerAlt
)

const app = createApp(App)

app.component('font-awesome-icon', FontAwesomeIcon)
app.use(store)
app.use(router)

app.mount('#app')





